<template>
    <el-popover
        @hide="filterHiden"
        placement="bottom"
        :width="360"
        trigger="click">
      <template #reference>
        <div v-if="type=='image'" class="select"></div>
        <el-button v-else type="primary">筛选</el-button>

      </template>
      <div class="coloums-list" @click.stop="closePop">
        <div class="coloums-title">筛选条件</div>
        <div class="items-select" @click.stop>
          <el-input @focus="openColoumName" v-model="columnNameInput" placeholder="选择列"
                    @input="coloumNameChange" clearable
                    @clear="selectColoumName='';"></el-input>
          <div class="myoption" v-show="coloumNameShow">
            <ul v-if="column_mapper_show">
              <li @click.stop="getColoumName(key)"
                  v-for="(item,key,index) in column_mapper_show" :key="index">
                {{ item.slice(0, item.lastIndexOf(":")) }}
              </li>
            </ul>
          </div>


        </div>
        <div class="items-select">
          <div class="myselect" @click.stop="openFilter">
            <span v-show=" JSON.stringify(filter)==='{}'">选择过滤器</span>
            <span v-show=" JSON.stringify(filter)!=='{}'"
                  style="color:rgba(96, 98, 102, 1);">{{ filter.label }}</span>
            <img src="../../../assets/img/Shape.png" alt="">
          </div>
          <div class="myoption" v-show="filterShow">
            <ul v-if="selectoption&&selectoption[0]">
              <template v-if="selectType==='number'">
                <li class="hoverCls" @click="getFilter(item)" v-for="(item,index) in selectoption[0]"
                    :key="index">{{
                    item.label
                  }}
                </li>
              </template>
              <template v-else-if="selectType==='string'">
                <li @click="getFilter(item)" v-for="(item,index) in selectoption[1]" :key="index">{{
                    item.label
                  }}
                </li>
              </template>
              <template v-else-if="selectType==='date'">
                <li @click="getFilter(item)" v-for="(item,index) in selectoption[2]" :key="index">{{
                    item.label
                  }}
                </li>
              </template>
              <template v-else-if="selectType==='like'">
                <li @click="getFilter(item)" v-for="(item,index) in selectoption[3]" :key="index">{{
                    item.label
                  }}
                </li>
              </template>
            </ul>
          </div>
        </div>
        <div class="items-select">
          <el-input v-model="columnValue"
                    :placeholder="selectType==='date'?'请输入日期(格式为yyyy-MM-dd)':'请输入内容'"></el-input>
        </div>
        <div class="btn-select">
          <el-button type="danger" @click="emptySelect"
                     style="width:138px;background: #FF4242;font-size: 16px;font-family: SourceHanSansSC-Regular, SourceHanSansSC;font-weight: 400;color: #FFFFFF;">
            清空所有
          </el-button>
          <el-button type="primary" @click="submitSelect"
                     style="font-size: 16px;background: #429FFF;font-family: SourceHanSansSC-Regular, SourceHanSansSC;font-weight: 400;color: #FFFFFF;">
            添加筛选条件
          </el-button>
        </div>
        <div class="result_title" v-show="queryCond.length>0">
          <div class="title">筛选过滤展示</div>
<!--          <div class="result">过滤结果：{{ totalnums }}条</div>-->
        </div>
        <div v-show="queryCond.length>0" style="padding-bottom:32px">
          <div class="select_list" v-for="item in queryCond">
                    <span
                        class="text">{{
                        column_mapper[item.columnName] ? column_mapper[item.columnName].slice(0, column_mapper[item.columnName].lastIndexOf(':')) : ""
                      }} {{ filter_mapper[item.filter] }} {{ item.columnValue }}</span>
            <img class="hoverCls" src="../../../assets/img/delete_select.png" alt="" @click="removeSelect(item)">
          </div>
        </div>
      </div>
    </el-popover>
</template>

<script>
import selectoption from "@/component/assets/selectoption.json";

export default {
  name: "CustomFilter",
  props:{
    column_mapper:{
      type:Object
    },
    type:{
      type:String,
      default:'image'
    }
  },
  data(){
    return {
      // column_mapper: {
      //   "quotation_type": "计价类型:varchar",
      //   "business_type": "业务类型:varchar",
      //   "responsible_p_dept": "部门:varchar",
      //   "responsible_s_dept": "业务组:varchar",
      //   "ateam": "销售组:varchar",
      //   "client_name": "客户:varchar",
      //   "account_manager": "客户经理:varchar",
      //   "project_manager": "项目经理:varchar",
      // },//表头所有列的枚举
      totalnums: 0,//所有的数据条数


      //筛选条件相关
      //筛选条件-第一步-选择列
      columnNameInput: '',//1、input输入框内容
      coloumNameShow: false,//2、点击input后开关下拉弹窗
      coloumName: "",//3、选中下拉框的一个列后，获得列的key，如'amount:charge'
      //筛选条件-第二步-选择过滤器
      filterShow: false,//1、开关过滤器下拉弹窗
      selectoption: [],//2、下拉弹窗的过滤条件列表（/src/component/assets/selectoption.json）
      filter: {},//3、下拉弹窗过滤条件列表的过滤选中的值  {"value":"gt","label":"大于"}
      //筛选条件-第三步-填写条件值
      columnValue: '',//筛选的条件值
      //筛选条件-结果
      filter_mapper: {},//筛选条件的枚举，用与筛选结果中逻辑的值（如大于、等于）显示
      queryCond: [],//筛选结果的列表
    }
  },
  mounted() {
    this.selectoption = selectoption.selectoption
    this.filter_mapper = selectoption.filter_mapper
  },
  computed:{
    /**
     * 筛选条件-选择列输入框中输入内容后过滤出的列的列表
     * @returns {{}}
     */
    column_mapper_show() {
      let x = {}
      // console.log('this.column_mapper',this.column_mapper)
      if (!this.column_mapper) return x
      for (let key in this.column_mapper) {
        if (this.column_mapper[key].indexOf(this.columnNameInput) !== -1) {
          x[key] = this.column_mapper[key]
        }
      }
      // console.log('x',x)
      return x
    },
    /**
     * 筛选条件-选择过滤器-根据不同列的类型，显示不同过滤器列表
     * @returns {string}
     */
    selectType() {
      if (this.column_mapper[this.coloumName]) {
        var type = this.column_mapper[this.coloumName].slice(this.column_mapper[this.coloumName].lastIndexOf(':') + 1)
        // console.log(type)
        if (type === "decimal" || type === "int") {
          return 'number'
        } else if (type === 'varchar') {
          var filterType = this.column_mapper[this.coloumName].slice(0, 2)
          if (filterType == '时间') {
            return 'date'
          } else {
            return 'string'
          }
        }else if(type==='like') {
          return 'like'
        } else {
          return 'date'
        }
      }
    },
  },
  methods:{
    //-----------筛选
    /**
     * 隐藏筛选条件弹窗
     */
    filterHiden() {
      // console.log('filterHiden')
      this.coloumNameShow = false;
      this.filterShow = false
    },

    /**
     * 筛选条件-选择列-弹出列的列表
     */
    openColoumName() {
      // console.log('openColoumName')
      if (this.filterShow) {
        this.filterShow = !this.filterShow
      } else {
      }
      this.coloumNameShow = true;
    },

    /**
     * 关闭弹窗
     */
    closePop(){
      this.$nextTick(()=>{
        this.coloumNameShow = false;
        this.filterShow = false;
      })
    },

    /**
     * 筛选条件-选择列-输入框输入内容时，保存弹窗弹出
     */
    coloumNameChange() {
      // console.log('coloumNameChange')
      this.coloumNameShow = true
    },

    /**
     * 筛选条件-选择列-选择弹窗列表的某个item
     * @param coloumName 选择列的key
     */
    getColoumName(coloumName) {
      // console.log('getColoumName')
      this.filter = {}
      this.coloumName = coloumName;
      this.columnNameInput = this.column_mapper[this.coloumName].slice(0, this.column_mapper[this.coloumName].lastIndexOf(":"))
      this.coloumNameShow = false
    },



    /**
     * 筛选条件-选择过滤器-弹出过滤条件的列表
     */
    openFilter() {
      // console.log('openFilter')
      if (this.coloumNameShow) {//如果选择列弹窗弹出了，则关闭弹窗
        this.coloumNameShow = !this.coloumNameShow
      }
      if (this.coloumName === "") {//如果选择列没有选，则弹出选择列列表
        this.openColoumName()
        return
      }

      //打开过滤器列表
      this.filterShow = !this.filterShow
    },

    /**
     * 筛选条件-选择过滤器-选择弹出过滤条件的某个item
     * @param filter 过滤条件的字典
     */
    getFilter(filter) {
      // console.log('getFilter:filter', filter)
      this.filter = filter
      this.filterShow = false
    },

    /**
     * 清空筛选条件
     */
    emptySelect() {
      // console.log('清空筛选条件')
      this.coloumName = ""
      this.columnNameInput = ""
      this.filter = {}
      this.columnValue = ""
      this.queryCond = []
      this.findSelsectChanged('emptySelect')
    },

    findSelsectChanged(){
      this.$emit('filterChange',this.queryCond)
    },
    /**
     * 提交筛选条件
     */
    submitSelect() {
      if (this.coloumName === '' || this.filter === '' || this.columnValue === '') {
        this.$message.warning({
          message: '内容不能为空',
          type: 'warning',
          duration: 1000
        });
        return
      }
      if (this.selectType === 'date') {
        if (!(isNaN(this.columnValue) && !isNaN(Date.parse(this.columnValue))) || this.columnValue.length != 10) {
          this.$message.warning({
            message: '未输入正确时间格式',
            type: 'warning',
            duration: 1000
          });
          return
        }
      }
      let item = {
        filter: this.filter.value,
        columnName: this.coloumName
      }
      // console.log('submitSelect:item', item)
      //在列表和不在列表条件需要单独处理
      if (this.filter.value === "in" || this.filter.value === "nin") {
        // console.log('------------------')
        let ishave = this.queryCond.some((item) => {
          if (item.columnName === this.coloumName && item.filter === this.filter.value) {
            //用中文或因为的逗号作分割
            this.columnValue.split(/[,，]/).forEach((i) => {
              item.columnValue.unshift(i)
            })
            return true
          }
        })
        if (!ishave) {
          item.columnValue = this.columnValue.split(/[,，]/)
          // console.log(item)
          this.queryCond.unshift(item)
        }
        this.findSelsectChanged('submitSelect1')
        // this.queryPagedata()
        this.coloumName = ""
        this.columnNameInput = ""
        this.filter = {}
        this.columnValue = ""
        return
      }
      item.columnValue = this.columnValue
      // console.log('submitSelect:item:after', item)
      this.queryCond.unshift(item)//当前查询条件插入查询条件列表最前面
      // console.log('submitSelect:this.queryCond', this.queryCond)
      this.findSelsectChanged('submitSelect2')
      this.coloumName = ""
      this.columnNameInput = ""
      this.filter = {}
      this.columnValue = ""


    },

    submitSelectByQueryCond(queryCond){
      //清理互斥的条件
      this.queryCond = this.queryCond.filter(q=>!q.type)
      this.queryCond.unshift(queryCond)
      this.findSelsectChanged('submitSelectByQueryCond')

    },
    /**
     * 筛选条件结果列表，移除某个筛选结果条件
     * @param e
     */
    removeSelect(e) {
      let num = 0
      this.queryCond.forEach((item, index) => {
        if (JSON.stringify(item) === JSON.stringify(e)) {
          num = index
        }
      })
      this.queryCond.splice(num, 1)
      this.findSelsectChanged('removeSelect')
      if (this.isSummary) {
        this.querySummaryPageData()
      }
    },

    /**
     * 列筛选item点击
     * @param item 被点击的列筛选条件
     */
    coloumsChange(item) {
      if (item === "project:project_id" || item === "project:project_name") {
        this.$message.warning({
          message: '此列为必显示列',
          type: 'warning',
          duration: 1000
        });
        return
      }
      //如果当前显示列列表中不存在该点击列时，添加进去
      if (this.showColoums.indexOf(item) === -1) {
        this.showColoums.push(item)
        this.findSelsectChanged('coloumsChange1')
      } else {//否则从当前显示列中移除
        //列数至少为1
        if (this.showColoums.length === 1) {
          this.$message.warning({
            message: '必须有一列数据可视',
            type: 'warning',
            duration: 1000
          });
          return
        }
        //删除从当前列列表中移除item
        this.showColoums.splice(this.showColoums.indexOf(item), 1)
        this.findSelsectChanged('coloumsChange2')
      }
    },
  }
}
</script>

<style scoped lang="scss">
.select {
  width: 22px;
  height: 22px;
  background-image: url("../../../assets/img/select.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  &:hover::before {
    content: '筛选条件';
    display: block;
    position: absolute;
    top: calc(100% + 12px);
    left: 50%;
    transform: translateX(-50%);
    background: #9FA8B3;
    color: rgb(255, 255, 255);
    font-size: 12px;
    font-family: SourceHanSansSC-Regular, SourceHanSansSC;
    font-weight: 400;
    width: 50px;
    padding: 5px;
    border-radius: 3px;
    z-index: 999;
  }

  &:hover {
    background-image: url("../../../assets/img/select_active.png");
  }
}
.coloums-list {
  width: 360px;
// height:495px;
  box-shadow: 0px 0px 12px 0px rgba(143, 159, 182, 0.2);

.el-input__inner {
  width: 320px;
  height: 36px;
  background: #F5F8FF;
  border-radius: 2px;
  border: none;
  border-left: 3px solid #E2EAF7;
  font-size: 14px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
}

.el-input__suffix {
  margin-right: 20px;
}

.items-select {
  height: 46px;
  padding-left: 20px;

.myselect {
&:hover {
   cursor: pointer;
 }

display: flex;
justify-content: space-between;
align-items: center;
padding: 0 14px 0 12px;
height: 36px;
width: 320px;
background: #F5F8FF;
border-left: 3px solid #E2EAF7;
color: rgb(202, 196, 214);
box-sizing: border-box;

img {
  height: 5px;
  width: 8px;
}
}

.myoption {
  position: relative;
  top: 10px;
  z-index: 200;
  width: 320px;
  max-height: 300px;
  overflow-y: auto;
  background: rgb(255, 255, 255);
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 10%);
  border-radius: 0 0 2px 2px;
  padding: 6px 0;

ul {
// background-color: red;
li {
  height: 34px;
  line-height: 34px;
  padding: 0 20px;

&:hover {
   background: rgb(245, 247, 250);
 }
}
}
}
}

.btn-select {
  width: 320px;
  margin: 10px 20px;
  display: flex;
  justify-content: space-between;
}

.coloums-title {
  height: 54px;
  line-height: 60px;
  text-align: center;
  font-size: 16px;
  font-family: SourceHanSansSC-Medium, SourceHanSansSC;
  font-weight: 500;
  color: #586A84;
}

.result_title {
  padding-top: 4px;
  text-align: center;
  font-size: 16px;
  font-family: SourceHanSansSC-Medium, SourceHanSansSC;
  font-weight: 500;
  color: #586A84;

.result {
  margin-top: 4px;
  font-size: 12px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  color: #586A84;
}
}

.select_list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 20px;
  width: 299px;
  padding-left: 9px;
  padding-right: 12px;
  background: #F5F8FF;
  border-radius: 2px;
  border-left: 3px solid #E2EAF7;
  height: 36px;
  .text{
    padding-left: 0px;
  }
}

.items {
  font-size: 14px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  color: #586A84;
  height: 430px;
  overflow-y: auto;

.item {
  height: 36px;
  line-height: 36px;
  text-align: center;

&:hover {
   cursor: pointer;
   background: #F5F8FF;
   opacity: 0.9;
   font-family: SourceHanSansSC-Medium, SourceHanSansSC;
   font-weight: 500;
   color: #429FFF;
 }
}

.selected {
  background: #F5F8FF;
  opacity: 0.9;
  font-family: SourceHanSansSC-Medium, SourceHanSansSC;
  font-weight: 500;
  color: #429FFF;
}

.item-coloums {
  height: 36px;
  line-height: 36px;
  padding-left: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;

img {
  margin-right: 10px;
}

&:hover {
   cursor: pointer;
   background: #F5F8FF;
   opacity: 0.9;
   font-family: SourceHanSansSC-Medium, SourceHanSansSC;
   font-weight: 500;
   color: #429FFF;
 }
}
}
}

.hoverCls:hover {
  cursor: pointer;
}

.text {
  .el-input .el-input__count .el-input__count-inner {
    background: none;
  }

  .el-input__inner {
    height: 50px;
    //width: 272px;
    background: #EBEFF7;
    border: none;
    // border-left:1px solid rgba(57, 148, 241, .5);
    padding-left: 4px;
    margin-left: -30px;
    padding-left: 30px;
    font-size: 16px;
    font-family: SourceHanSansSC-Regular, SourceHanSansSC;
    font-weight: 400;
    border-radius: 0;
    // color: #3994F1;
  }

  input::-webkit-input-placeholder {
    font-size: 16px;
    font-family: SourceHanSansSC-Regular, SourceHanSansSC;
    font-weight: 400;
    color: rgba(57, 148, 241, .4);
  }

  display: flex;
  align-items: center;
  padding-left: 30px;
  height: 50px;
  line-height: 50px;

  .dot {
    width: 10px;
    height: 10px;
    margin-right: 6px;
  }
}
</style>
